/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Review_Pdf_TitleInputs */

const da_review_pdf_title = /** @type {(inputs: Review_Pdf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besvarelsen`)
};

/** @type {(inputs: Review_Pdf_TitleInputs) => LocalizedString} */
const en_review_pdf_title = da_review_pdf_title;

/**

* @param {Review_Pdf_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const review_pdf_title = /** @type {((inputs?: Review_Pdf_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_Pdf_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_review_pdf_title(inputs)
	return /** @type {LocalizedString} */ ("Besvarelsen")
});